import { Upload } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { Alert } from "rsuite";
import { Context } from "../../Context";
import "../../assets/styles/custom/CustomCarousel.scss";
import "../../assets/styles/custom/fb.scss";
import SelectedImageAndFolderModal from "../../components/selectedImageAndFolderModal";
import constants from "../../constants";
import LibraryModal from "../LibraryModal";
import "./CustomInput";
import CustomInput from "./CustomInput";
const { Dragger } = Upload;

export default class CustomCarousel extends Component {
	static contextType = Context;

	componentDidMount() {
		this.props.onRef(this);
		let carousel_array_updated = this.props.child_attachments.map(
			(item, index) => {
				return index + 1;
			},
		);
		this.setState({ carousel_array: carousel_array_updated });
		this.state.carousel_array.map((item, index) => {
			this.showCard(item);
		});
	}
	componentWillUnmount() {
		this.props.onRef(null);
	}
	constructor(props) {
		super(props);
		this.state = {
			carousel_array: [1],
			active: 1,

			active_element: {
				headline: "",
				description: "",
				link: "",
				picture: "",
				call_to_action: {
					type: "",
				},
			},
			valid: {
				call_to_action: false,
			},
			child_attachments: this.props.child_attachments,
			uploadedFileUrl: [],
			library_modal: false,
			library_data: [],
			selected_image: [],
			openImageModal: false,
			selectedImageFile: {},
			SeletedFiles: [],
			SelectedFilesEvent: [],
			SelectedFilesName: [],
		};
	}

	addCard = () => {
		let value = this.state.carousel_array.length + 1;
		let active = this.state.active;
		let carousel_array = this.state.carousel_array;
		carousel_array.push(value);
		value = value + 1;
		this.setState({ carousel_array, value, active });
		active = this.state.carousel_array.length;
		this.setState({ active });
	};

	pushValues = () => {
		let newvalues = this.state.child_attachments;
		newvalues.push({
			headline: "",
			description: "",
			link: "",
			picture: "",
			call_to_action: {
				type: this.props.post_cta,
			},
		});
		let index = newvalues.length - 1;
		let active_element = this.state;
		this.setState({ active_element: newvalues[index] });
		console.log(active_element);
	};

	showCard = (key) => {
		this.setState(
			{
				active: key,
				active_element: this.state.child_attachments[key - 1],
			},
			() => {
				console.log(this.state.active);
				console.log(this.state.active_element);
			},
		);
	};
	deleteCard(active) {
		let { carousel_array } = this.state;
		let len = carousel_array.length;
		let { child_attachments } = this.state;
		let { active_element } = this.state;
		child_attachments.splice(this.state.active - 1, 1);
		this.setState({
			child_attachments,
		});
		if (len - 1 !== 0) {
			active = 1;
			carousel_array.splice(len - 1, 1);
			this.setState({
				carousel_array,
				active,
				active_element: child_attachments[0],
			});
			console.log(carousel_array);
			console.log(active);
		}
	}

	updateCTA = (value) => {
		let child_attachments = this.state.child_attachments;
		let active_element = this.state.active_element;
		active_element.call_to_action.type = value;
		child_attachments = child_attachments.map((item, index) => {
			item.call_to_action.type = value;
			return item;
		});
		this.setState({ child_attachments, active_element });
	};

	setuploadFiles = async function (file) {
		const form_data = new FormData();
		form_data.append("files", file);
		this.setState({ video_filename: file.name });

		try {
			let uploadData = {
				method: "post",
				url: constants.upload,
				headers: {
					Authorization: `Bearer ${window.localStorage.getItem("user_token")}`,
				},
				data: form_data,
			};
			let uplaodedImage = await axios(uploadData);
			return uplaodedImage;
		} catch (error) {
			console.log(error);
		}
	};

	sethandleUploadedFiles = (e, single) => {
		if (!/(\.jpg|\.jpeg)$/i.exec(e.file.name)) {
			Alert.error(`Supported file formats are: JPG, JPEG.`);
			return;
		}
		if (e.file.size > 8388608) {
			Alert.error(`You are exceeding 8MB image limit`);
			return;
		}
		this.setState({ SelectedFilesEvent: [] });
		this.state.SelectedFilesEvent.push(e);
		this.state.SelectedFilesName.push(e.file.name);
		console.log(
			"SelectedFilesEvent",
			this.state.SelectedFilesEvent,
			this.state.SelectedFilesName,
		);
		this.setState({ openImageModal: true, selectedImageFile: e });
	};

	closeImageModal = function () {
		console.log("FB - Clicked on Cancel");
		this.setState({ openImageModal: false, SelectedFilesName: [] });
	}.bind(this);

	handleImageModalOK = function () {
		console.log("FB - Clicked on OK");
		this.setState({ openImageModal: false });
	}.bind(this);

	selectedFolderName = (selected_folder) => {
		console.log(
			"selected_folder",
			selected_folder,
			this.state.SelectedFilesEvent,
		);
		this.uploadImageFiles(
			this.state.SelectedFilesEvent,
			false,
			selected_folder,
		);
	};

	uploadImageFiles = async (e, single, folder) => {
		this.setState({ loading: true });
		for (const ev of e) {
			this.setuploadFiles(ev.file).then((res) => {
				//change for image
				if (single) {
					this.setState({
						uploadedFileUrl: [res.data[0].url],
						videoname: [res.data[0].name],
					});
				} else {
					const newVal = this.state.uploadedFileUrl;
					const child_attachments = this.state.child_attachments;
					const url = this.state.active_element;
					url.picture = res.data[0].url;
					this.setState({ active_element: url });
					this.props.update(this.state.child_attachments);
					console.log(child_attachments);
					newVal.push(res.data[0].url);
					this.setState({
						uploadedFileUrl: newVal,
					});
				}
				if (res.data && res.data[0].url) {
					try {
						let uploadAWS = {
							method: "post",
							url: constants.mediamanager_upload,
							headers: {
								Authorization: `Bearer ${window.localStorage.getItem(
									"user_token",
								)}`,
							},
							data: {
								files: res.data[0].url,
								path: res.data[0].name,
								folder: folder,
								size: ev.file.size,
							},
						};
						axios(uploadAWS);
					} catch (error) {
						console.log(error);
					}
				}
			});
		}
	};

	setselectFromLibrary = () => {
		this.setState({ library_modal: true });
		const bucketBody = {
			url: constants.get_accessible_images,
			method: "POST",
			headers: {
				Authorization: `Bearer ${window.localStorage.getItem("user_token")}`,
			},
			data: {
				folders_accessible: this.context.contextState.folders_accessible,
			},
		};

		axios(bucketBody)
			.then((response) => {
				let data = response.data;
				// const filter = [];
				// for (const i of data) {
				//   if (i["public-url"]) {
				//     const checklast = i["public-url"].charAt(
				//       i["public-url"].length - 1
				//     );
				//     if (checklast != "/") {
				//       if (i["mime-type"].includes("video"))
				//         i["video-type"] = i["mime-type"];
				//       filter.push(i);
				//     }
				//   }
				//   i["mime-type"] = "application/directory";
				// }
				this.setState({ library_data: data });
			})
			.catch((error) => {
				console.log(error);
			});
	};

	setselectimage = (e, active) => {
		const child_attachments = this.state.child_attachments;
		const newVal = this.state.uploadedFileUrl;
		e.map((data, index) => {
			newVal.push(data);
		});
		if (e.length == 1) {
			child_attachments[active - 1].picture = e[0];
		} else {
			Alert.error("You can select only one image from library for each card!");
		}
		this.setState({
			uploadedFileUrl: newVal,
			child_attachments: child_attachments,
		});
		this.props.update(this.state.child_attachments);
	};
	removeImage = (value) => {
		let child_attachments = this.state.child_attachments;
		child_attachments[value - 1].picture = "";
		this.setState({
			child_attachments,
		});
		this.props.update(this.state.child_attachments);
	};
	setrenderImages = () => {
		return (
			<div className="field images">
				<div className="image-container">
					<div
						className="close-btn"
						onClick={(e) => this.removeImage(this.state.active)}
					/>
					{this.state.postType !== "video" ? (
						<img className="img" src={this.state.active_element.picture} />
					) : (
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								height: "80px",
								width: "100%",
								background: "#ddd",
								borderRadius: 5,
							}}
							className="img"
						>
							<p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
								{this.state.videoname}
							</p>
						</div>
					)}
				</div>
			</div>
		);
	};

	changeHandler = () => {
		let child_attachments = this.state.child_attachments;
		let key = this.state.active;
		let active_element = this.state.active_element;
		child_attachments[key - 1] = active_element;
		this.setState({
			child_attachments,
		});
	};

	render() {
		const { allowedFileFormats, allowedFileSize } = this.props;
		return (
			<div className="container">
				<ul className="d-flex">
					{this.state.carousel_array.map((item, index) => (
						<button
							className={"btn idm-carousel-btns"}
							style={item === this.state.active ? { background: "#27272F", color: "#fff", padding: "6px 12px" } : { background: "#e2e2e2", padding: "6px 12px" }}
							onClick={() => {
								this.showCard(item);
							}}
							key={item}
						>
							{item}{" "}
						</button>
					))}
					{this.state.child_attachments.length >= 10 ? null : (
						<button
							className="idm-carousel-add-btn"
							onClick={() => {
								this.addCard();
								this.pushValues();
								this.props.update(this.state.child_attachments);
							}}
						>
							<span>+</span>
						</button>
					)}
				</ul>
				<div className="input-form">
					{this.state.active === 1 ? null : (
						<div>
							<button
								className="remove-button"
								disabled={this.state.active === 1}
								onClick={(active) => {
									this.deleteCard(active);
									this.props.update(this.state.child_attachments);
								}}
							>
								Remove
							</button>{" "}
							<br />
						</div>
					)}
					<br />
					<form>
						<div className="field">
							<CustomInput
								type="text"
								name="headline"
								label={`Headline for Card ${this.state.active}`}
								value={this.state.active_element.headline}
								maxLength={25}
								onInput={(e) => {
									let y = this.state.active_element;
									y.headline = e.target.value;
									this.setState({ active_element: y });
									this.changeHandler(e);
									this.props.update(this.state.child_attachments);
								}}
								helperText="Please enter the headline of the card"
							/>
						</div>
						<div className="field">
							<CustomInput
								type="text"
								name="description"
								label={`Description for Card ${this.state.active}`}
								value={this.state.active_element.description}
								maxLength={20}
								onInput={(e) => {
									let y = this.state.active_element;
									y.description = e.target.value;
									this.setState({ active_element: y });
									this.changeHandler(e);
									this.props.update(this.state.child_attachments);
								}}
								helperText="Please enter the description of the card"
							/>
						</div>
						<div className="field">
							<CustomInput
								type="url"
								name="link"
								label={`Link for Card ${this.state.active}`}
								value={this.state.active_element.link}
								onInput={(e) => {
									let y = this.state.active_element;
									y.link = e.target.value;
									this.setState({ active_element: y });
									this.changeHandler(e);
									this.props.update(this.state.child_attachments);
								}}
								helperText="Please enter the Link url"
							/>
						</div>
					</form>
					<div className="image-container">
						<div className="field">
							<p className="field-title">Upload Image*</p>
							<div className="field-box">
								<p
									className="MuiFormHelperText-root MuiFormHelperText-contained"
									id="custom-css-outlined-input-helper-text"
								>
									Maximum image size is allowed upto 8MB
								</p>
								<Dragger
									disabled={this.props.read_only}
									name="file"
									multiple={false}
									showUploadList={false}
									customRequest={this.sethandleUploadedFiles}
									className="upload-dragger animated fadeIn"
								>
									<p className="ant-upload-text">
										Click or drag the image files to upload
									</p>
									<p className="ant-upload-hint">Image</p>
								</Dragger>
							</div>
							<div className="image-divider">or</div>
							{this.props.read_only ? (
								<div className="field-box selection-box">
									Select From Library
								</div>
							) : (
								<div
									className="field-box selection-box"
									onClick={() => this.setselectFromLibrary()}
								>
									Select From Library
								</div>
							)}
							<LibraryModal
								allowedFileSize={allowedFileSize}
								allowedFileFormats={allowedFileFormats || []}
								library_modal={this.state.library_modal}
								library_data={this.state.library_data}
								selected_image={(e) =>
									this.setselectimage(e, this.state.active)
								}
								onCancel={() => this.setState({ library_modal: false })}
							/>
						</div>

						{this.state.active_element.picture ? this.setrenderImages() : null}
					</div>
				</div>
				<SelectedImageAndFolderModal
					visible={this.state.openImageModal}
					onOk={this.handleImageModalOK}
					onCancel={this.closeImageModal}
					done={this.state.selectedImageFile}
					isFB={true}
					selectedFolderName={this.selectedFolderName}
					handleUploadedFiles={this.handleUploadedFiles}
					selectedImageFile={this.state.SelectedFilesName}
				></SelectedImageAndFolderModal>
				<br />
			</div>
		);
	}
}

CustomCarousel.defaultProps = {
	allowedFileSize: null,
	allowedFileFormats: [],
};
